import config from "../../config.json";

const STOP_TRANSLATION_STORAGE_KEY = "vehicleScreenStopNameTranslations";

const DISPLAY_LANGUAGE_ALIASES = {
  cn: "zh",
  "zh-cn": "zh",
  ka: "kn",
  sa: "ar",
};

export const normalizeDisplayLanguage = (language) => {
  const normalized = String(language || "en")
    .trim()
    .toLowerCase()
    .replace("_", "-");

  return DISPLAY_LANGUAGE_ALIASES[normalized] || normalized.split("-")[0] || "en";
};

const readStoredStopTranslations = () => {
  if (typeof window === "undefined") return {};

  try {
    return JSON.parse(localStorage.getItem(STOP_TRANSLATION_STORAGE_KEY)) || {};
  } catch (error) {
    console.error("Error reading stop translation cache:", error);
    return {};
  }
};

const writeStoredStopTranslation = (cacheKey, value) => {
  if (typeof window === "undefined") return;

  try {
    const storedTranslations = readStoredStopTranslations();
    storedTranslations[cacheKey] = value;
    localStorage.setItem(
      STOP_TRANSLATION_STORAGE_KEY,
      JSON.stringify(storedTranslations)
    );
  } catch (error) {
    console.error("Error saving stop translation cache:", error);
  }
};

export const translateStopName = async (stopName, language, cacheRef) => {
  const sourceStopName = String(stopName || "").trim();
  const displayLanguage = normalizeDisplayLanguage(language);

  if (!sourceStopName || displayLanguage === "en") {
    return sourceStopName;
  }

  const cacheKey = `${displayLanguage}:${sourceStopName}`;
  const memoryCache = cacheRef?.current;
  const cachedTranslation =
    memoryCache?.get(cacheKey) || readStoredStopTranslations()[cacheKey];

  if (cachedTranslation) {
    memoryCache?.set(cacheKey, cachedTranslation);
    return cachedTranslation;
  }

  const query = new URLSearchParams({
    text: sourceStopName,
    language: displayLanguage,
  });
  const response = await fetch(
    `${config.baseURL}/announcement/translate-text?${query.toString()}`,
    { credentials: "include" }
  );

  if (!response.ok) {
    throw new Error(`Translation API error: ${response.status}`);
  }

  const data = await response.json();
  const translatedText = data?.text || sourceStopName;

  memoryCache?.set(cacheKey, translatedText);
  writeStoredStopTranslation(cacheKey, translatedText);

  return translatedText;
};
